import moment from 'moment';

export default (state, action) => {
    if (!state) {
        state = {
            loaded: false,
            fetchTime: null,
            sessions: [],
        };
    }

    switch (action.type) {
        case 'VOTING_UPDATE_SESSIONS':
            state = {
                ...state,
                loaded: true,
                fetchTime: action.fetchTime,
                sessions: action.sessions,
            };
            break;
    }

    return state;
};
